/**
 * User storage utilities - extracted to avoid circular dependencies.
 * These functions are used by env.dev.ts which is loaded early in the app lifecycle.
 */
import { LOGGED_IN_USER } from './localStorageKeys';

export interface StoredUser {
    id: string;
    email: string;
    familyName: string;
    givenName: string;
    username: string;
}

export const getEntitlementGroup = (key: string): string[] => {
    const entitlementGroupValue = localStorage.getItem(key);
    if (entitlementGroupValue) {
        return JSON.parse(entitlementGroupValue);
    }
    // Lazy import to avoid circular dependency
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    const { endpointConfig } = require('../configuration/configuration');
    return [`${endpointConfig.env.ROLE_PREFIX}.BEAM_USER`, `${endpointConfig.env.ROLE_PREFIX}.BEAM_ADMIN`];
};

export const getLocallyStoredUser = (): StoredUser | undefined => {
    const loggedInUser = localStorage.getItem(LOGGED_IN_USER);
    return loggedInUser ? JSON.parse(loggedInUser) : undefined;
};

export const setLocallyStoredUser = (loggedInUser: StoredUser | undefined): void => {
    localStorage.setItem(LOGGED_IN_USER, JSON.stringify(loggedInUser ?? {}));
};
